import Posts from '../components/Posts';
import { PostsContextProvider } from '../context/PostsContext';
import { useAuthContext } from '../hooks/useAuthContext';

export default function Home() {
  const { authUser } = useAuthContext()

  return (
    <PostsContextProvider userId={authUser?.id} feedType="posts">
      <Posts userId={authUser?.id} feedType='posts' />
    </PostsContextProvider>
  )
}
